// extracted by mini-css-extract-plugin
export default {"wrapper":"search_decision_keywords-module__wrapper--2d0E2","article":"search_decision_keywords-module__article--VmDko","keyword":"search_decision_keywords-module__keyword--2rL3a"};